import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: 'int-closed-tag',
  templateUrl: './int-closed-tag.component.html',
  styleUrls: ['./int-closed-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntClosedTagComponent {

  @Input() isHide = false

  @Output() onClose = new EventEmitter();

  handleOnClick(event: Event) {
    event.stopPropagation();
    this.onClose.emit();
  }
}
